export const toPx = (value: number): string | null =>
  value ? `${Math.round(value)}px` : null;
